export enum VatType {
    ORDINARIO = 'ordinario',
    FORFETTARIO = 'forfettario',
    FORFETTARIO_STARTUP = 'forfettario_startup',
    ALTRO = 'altro',
  }